import React from "react";
import styles from "./CartSkeleton.module.scss";

export const CartSkeleton: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.cartItems}>
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className={styles.item}>
            <div className={styles.leftSide}>
              <div className={styles.titleSkeleton} />
              <div className={styles.subtitleSkeleton} />
              <div className={styles.dateSkeleton} />
            </div>
            <div className={styles.rightSide}>
              <div className={styles.iconSkeleton} />
              <div className={styles.priceSkeleton} />
            </div>
          </div>
        ))}
      </div>
      <div className={styles.sidebar}>
        <div className={styles.checkboxSkeleton} />
        <div className={styles.checkboxSkeleton} />
        <div className={styles.totalSkeleton} />
        <div className={styles.buttonSkeleton} />
      </div>
    </div>
  );
};
